import { takeEvery, put } from 'redux-saga/effects';

import companiesActions from '../actionTypes/companiesActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { ADD_NEW_COMPANY, UPDATE_COMPANY } from '../routes';


function* addNewCompany({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: ADD_NEW_COMPANY,
      method: 'POST',
      data: payload,
    },
    successAction: companiesActions.addNewCompanySuccess,
    failureAction: companiesActions.addNewCompanyFailed,
  });
}

function* updateCompany({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_COMPANY.replace(
        ':id',
        payload.get('company[id]'),
      ),
      method: 'PUT',
      data: payload,
    },
    successAction: companiesActions.updateCompanyDetailsSuccess,
    failureAction: companiesActions.updateCompanyDetailsFailed,
  });
}

export default function* watchCompany() {
  yield takeEvery(companiesActions.addNewCompany, addNewCompany);
  yield takeEvery(companiesActions.updateCompanyDetails, updateCompany);
}
